import { ReactComponent as LuxuryLifestyle } from "../assets/img/luxurylifestyle.svg";
import { ReactComponent as MinimilistLiving } from "../assets/img/minimilistliving.svg";
import { ReactComponent as mantainStatusQue } from "../assets/img/statusmanintque.svg";
import { String } from "./Strings";

export const RetirementCards = [
  {
    image: LuxuryLifestyle,
    description:
      "Wish to live a luxurious 2nd Innings of life without worrying about financial liabilities while spending.",
    text: String.Retirement.SecondInning.CardName.c1,
  },
  {
    image: mantainStatusQue,
    description:
      "Be satisfied with your current circumstances and financial situation.",
    text: "Current Comfort",
  },
  {
    image: MinimilistLiving,
    description:
      "Prefer a simple and organized living with a focus on life essentials",
    text: String.Retirement.SecondInning.CardName.c3,
  },
];
